import React, { type FC } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { TextField } from '../text-field';
import type { Field } from '../types';
import { UrlFieldReadView } from './read-view';
import { validate } from './utils';

export const UrlField: FC<Field> = ({
	id,
	label,
	value,
	onChange,
	isInline,
	getValueContainer,
}) => {
	const { formatMessage } = useIntl();

	return (
		<TextField
			id={id}
			label={label}
			value={value}
			onChange={onChange}
			validate={validate(formatMessage)}
			isInline={isInline}
			getValueContainer={getValueContainer}
			readView={() => (
				<UrlFieldReadView value={value} getValueContainer={getValueContainer} inInlineEdit />
			)}
		/>
	);
};

export { UrlFieldReadView };
